export const CIELO = 100;
export const CIELO_DIGITAL = 4;
export const REDE = 101;
export const GETNET = 102;
export const STONE = 103;
export const GLOBAL = 105;
export const PAG_SEGURO = 108;
export const SAFRA = 110;
export const PICPAY = 113;
export const SIPAG_SICOOB = 114;
export const STELO = 201;
export const VERO = 202;
export const MERCADO_PAGO = 204;
export const PAY_GO = 205;
export const SITEF = 206;
export const YUNO = 11;
export const SUMUP = 208;

export const ADYEN = 111;
export const IFOOD = 88888888;
export const FOOD99 = 99;
export const KEETA = 17;

export const TON = 10301;

export const FISERV = 104;
export const AZULZINHA = 10401;
export const AFINZ = 10403;
export const SICREDI = 10404;
export const XP = 10405;
export const CRESOL = 10406;
export const BCJ = 10407;
export const PORTOBANK = 10408;
export const UNICRED = 10409;
export const QLUB = 13;
export const QLIC = 16;
export const TRIBANCO = 109;
export const BS2ADIQ = 215;
